import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { selectChannelById } from 'store/programs/selectors';
import { EpgProgram, RBProgram } from 'store/railsBuilder/reducer.types';
import { RecordingMetadata } from 'store/recordings/reducer.types';
import { ReduxStore } from 'store/types';

import parseParentalRating from 'services/data-manager/parsing/utils/parseParentalRating';
import { VodEditorial } from 'services/data-manager/types';

import getChannelId from 'utils/getChannelId';

const useParentalRating = (
    program:
        | EpgProgram
        | RBProgram
        | VodEditorial
        | RecordingMetadata
        | undefined,
) => {
    const channelId = getChannelId(program);

    const channel = useSelector((state: ReduxStore) =>
        selectChannelById(state, channelId),
    );

    return useMemo(
        () => parseParentalRating(program, channel),
        [program, channel],
    );
};

export default useParentalRating;
